import { forwardRef } from "react";
import { Button } from "./button";

interface IconButtonProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  width?: number | string;
  height?: number | string;
  backgroundColor?: string;
  borderColor?: string;
  border?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  loadingColor?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      children,
      className,
      disabled,
      width,
      height,
      backgroundColor = "transparent",
      border = true,
      borderColor = "#E4E4E7",
      onClick,
      isLoading = false,
      loadingColor = "white",
      onMouseEnter,
      onMouseLeave,
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        isLoading={isLoading}
        loadingColor={loadingColor}
        className={`radius-md ${className}`}
        style={
          {
            border: border ? `1px solid ${borderColor}` : "none",
            borderColor: borderColor,
            backgroundColor: backgroundColor,
            width: width,
            height: height,
            transition: "background-color 0.2s ease",
          } as React.CSSProperties
        }
        disabled={disabled}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </Button>
    );
  }
);

IconButton.displayName = "IconButton";

export default IconButton;
